'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToSimple = convertToSimple;
exports.convertFromSimple = convertFromSimple;

var _availability = require('availability');

function convertToSimple(weekly) {
    var simple = (0, _availability.humanizeWeekly)(weekly).map(function (slot) {
        return {
            minuteOfDay: slot.window.minuteOfDay,
            durationMins: slot.window.durationMins,
            days: slot.days,
            allday: slot.window.durationMins === 24 * 60
        };
    });

    return simple;
}

function convertFromSimple(weekly) {
    var complex = [];

    weekly.forEach(function (slot) {
        slot.days.forEach(function (day) {
            if (slot.allday) {
                complex.push({
                    minuteOfWeek: day * 1440,
                    durationMins: 24 * 60
                });
            } else {
                var durationMins = slot.durationMins;
                if (durationMins <= 0) {
                    durationMins = 24 * 60 + durationMins;
                }

                var period = {
                    minuteOfWeek: slot.minuteOfDay + day * 1440,
                    durationMins: durationMins
                };

                if (period.minuteOfWeek + period.durationMins > 10080) {
                    complex.push({
                        minuteOfWeek: 0,
                        durationMins: period.durationMins - (10080 - period.minuteOfWeek)
                    }, {
                        minuteOfWeek: period.minuteOfWeek,
                        durationMins: 10080 - period.minuteOfWeek
                    });
                } else {
                    complex.push(period);
                }
            }
        });
    });

    complex.sort(function (a, b) {
        return a.minuteOfWeek - b.minuteOfWeek;
    });
    var changed = true;

    // Merge overlaps
    while (changed) {
        changed = false;

        for (var i = 1; i < complex.length; i++) {
            var prev = complex[i - 1];
            var curr = complex[i];
            if (prev.minuteOfWeek + prev.durationMins >= curr.minuteOfWeek && prev.minuteOfWeek + prev.durationMins >= curr.minuteOfWeek + curr.durationMins) {

                complex.splice(i, 1);
                changed = true;
            } else if (prev.minuteOfWeek + prev.durationMins >= curr.minuteOfWeek) {
                prev.durationMins += curr.durationMins - (prev.minuteOfWeek + prev.durationMins - curr.minuteOfWeek);

                complex.splice(i, 1);

                changed = true;
            }
        }
    }

    // // Handle 24/7
    // if (complex.length === 1 &&
    //     complex[0].durationMins === 10080 &&
    //     complex[0].minuteOfWeek === 0) {

    //     complex = [];
    // }

    return complex;
}